import request from "@/utils/request";

export default function changeState(id,state) {
    return request({
        url: `/storeType/agency/changeState/`+id+`/`+state,
        method: 'get',
    })
}
